export enum ActionTypes {
  GetIps = 'getIps',
  GetIpsRequest = 'getIps.request',
  GetIpsSuccess = 'getIps.success',
  GetIpsFailure = 'getIps.failure',
}
